import { AxiosRequestConfig } from "axios";
import { API_ENDPOINTS } from "../constants/ApiEndpoints";
import useApi from "./useApi";

export const useFindAllStaticData = (type: string) => {
    const requestConfig: AxiosRequestConfig = {
        url: API_ENDPOINTS.staticdata + type,
    };

    return useApi<string[]>(requestConfig);
};

/** Fetch all static data */
export const useFetchStaticData = () => {
    const [downloadStatusesResponse] = useFindAllStaticData('downloadStatuses');
    const [fileTypesResponse] = useFindAllStaticData('fileTypes');
    const [reportTypesResponse] = useFindAllStaticData('reportTypes');
    const [ownerTypesResponse] = useFindAllStaticData('ownerTypes');
    const [isCSClient] = useFindAllStaticData('isCSClient');

    return {
        downloadStatuses: downloadStatusesResponse.data ?? [],
        fileTypes: fileTypesResponse.data ?? [],
        reportTypes: reportTypesResponse.data ?? [],
        ownerTypes: ownerTypesResponse.data ?? [],
        isCSClient: isCSClient.data ?? [],
    }
}